import React, { createContext, useState, useContext, useEffect } from 'react';
import { connectToDevice, readCompassState, subscribeToCompassState, requestMapData, uploadMapData, readDeviceConfig } from './ble';

const BleContext = createContext();

export const useBle = () => useContext(BleContext);

export const BleProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [services, setServices] = useState({});

  useEffect(() => {
    if (services.device) {
      console.log('Adding gattserverdisconnected event listener');
      services.device.addEventListener('gattserverdisconnected', onDisconnected);
    }

    return () => {
      if (services.device) {
        console.log('Removing gattserverdisconnected event listener');
        services.device.removeEventListener('gattserverdisconnected', onDisconnected);
      }
    };
  }, [services.device]);

  const onDisconnected = () => {
    console.log('Device disconnected');
    setIsConnected(false);
    setServices({});
  };

  const connect = async () => {
    try {
      const { mapService, compassService, device } = await connectToDevice();
      setServices({ mapService, compassService, device });
      setIsConnected(true);
      console.log('Connected to device:', device);
    } catch (error) {
      console.error('Error connecting to device:', error);
      setIsConnected(false);
      setServices({});
    }
  };

  const disconnect = async () => {
    if (services.device) {
      await services.device.gatt.disconnect();
      setIsConnected(false);
      setServices({});
    }
  };

  const subscribeToCompassStateNotifications = async (callback) => {
    try {
      await subscribeToCompassState(services.compassService, callback);
    } catch (error) {
      console.error('Error subscribing to compass state notifications:', error);
    }
  };

  const readCompassStateData = async () => {
    if (services.compassService) {
      return await readCompassState();
    } else {
      console.warn('Compass service is not initialized');
      return null;
    }
  };

  const readDeviceConfigData = async () => {
    if (services.compassService) {
      return await readDeviceConfig();
    } else {
      console.warn('Compass service is not initialized');
      return null;
    }
  };

  return (
    <BleContext.Provider value={{
      isConnected,
      connect,
      disconnect,
      readCompassState: readCompassStateData,
      subscribeToCompassStateNotifications,
      requestMapData: (startCallback, progressCallback, completeCallback) => requestMapData(startCallback, progressCallback, completeCallback),
      uploadMapData: (points, progressCallback) => uploadMapData(points, progressCallback),
      readDeviceConfig: readDeviceConfigData
    }}>
      {children}
    </BleContext.Provider>
  );
};
